import { BaseEntity } from './base-entity';
import { Action } from './action';
export class RoleRightValue extends BaseEntity {
    Action: Action;
    Value: boolean;
    RoleID: number;

    Deserialize(input: any){
        if(!input)
            return null;

        this.Action = input.Action;
        this.Value = input.Value;
        this.RoleID = input.RoleID;

        return this;
    }
}